module.exports = __webpack_public_path__ + "img/cave56.e411792a.jpg";